'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var About = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(About, _Component);

  function About() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, About);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = About.__proto__ || (0, _getPrototypeOf2.default)(About)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showKitten: false
    }, _this.handleToggleKitten = function () {
      return _this.setState(function (prevState) {
        return { showKitten: !prevState.showKitten };
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(About, [{
    key: 'render',
    value: function render() {
      var showKitten = this.state.showKitten;
      var user = this.props.user;

      var kitten = require('./kitten.jpg');
      var exampleCamera = {
        email: 'test@getkuna.com',
        shared: true,
        upToDateFW: 1000,
        isFwUpToDate: false,
        isBetaFW: false,
        onPlan: true,
        timezone: 'GMT',
        camera: {
          build: 100,
          serial_number: 'OOKN0013375EAN01',
          name: 'My favorite test camera',
          status: 0,
          notifications_enabled: false,
          timezone: 'Not-GMT',
          owner: { email: 'owner@getkuna.com' }
        },
        logglyUrls: [{ name: 'Test URL', url: './search' }]
      };

      var issuelessCamera = JSON.parse((0, _stringify2.default)(exampleCamera));
      issuelessCamera.camera.owner.email = issuelessCamera.email;
      issuelessCamera.camera.build = issuelessCamera.upToDateFW;
      issuelessCamera.camera.notifications_enabled = true;
      issuelessCamera.camera.timezone = issuelessCamera.timezone;
      issuelessCamera.camera.subscription = {};
      issuelessCamera.isFwUpToDate = true;
      issuelessCamera.shared = false;

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'h1',
          null,
          'About'
        ),
        _react2.default.createElement(_reactHelmet2.default, { title: 'About' }),
        _react2.default.createElement(
          'p',
          null,
          'This tool is for Kuna employees and their official partners. It offers the tools necessary in order to support customers.'
        ),
        user && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Here is an example of a camera that has all of the properties that you can possibly see:'
          ),
          _react2.default.createElement(_components.Camera, exampleCamera),
          _react2.default.createElement(
            'p',
            null,
            'Here is an example of a camera where there are none of the above interesting properties'
          ),
          _react2.default.createElement(_components.Camera, issuelessCamera)
        ),
        _react2.default.createElement(
          'p',
          { style: { 'font-size': '5px' }, onClick: this.handleToggleKitten },
          showKitten ? 'No! Take it away!' : 'Psst! Would you like to see a kitten? Click here.'
        ),
        showKitten && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('img', { src: kitten, alt: '' })
        )
      );
    }
  }]);
  return About;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object
}, _temp2)) || _class);
exports.default = About;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/About/About.js
 ** module id = 1390
 ** module chunks = 0
 **/